import React, { useState, useEffect } from 'react';
import MaterialTable from '@material-table/core';
import { ExportCsv } from '@material-table/exporters';

import { config } from '../config';
import formatTime from '../functions/formatTime';
import { exportExcel } from '../functions/exportExcel';
import { useAuth } from '../hooks/useAuth';

const pathIds = window.location.pathname.split('/');


const CleaningReport = () => {
  const params = new URL(document.location).searchParams;
  const orgId = params.get('organization') || pathIds[1];
  const locationId = params.get('location') || pathIds[2];
  const [reportData, setReportData] = useState([]);
  const [hasError, setError] = useState(false);
  const { token, userRoles } = useAuth();
  const isUserRoleAtleastService = userRoles.some(role => 
    ['service', 'edit', 'admin'].includes(role)
  );

  useEffect(() => {
    // Fetch all timestamps from DB
    fetch(`${config.lnt_api_url}/report`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        orgId: orgId,
        locationId: locationId,
        token: token,
      }),
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.events !== undefined && json.events !== null) {
          sortData(json.events);
        }
      })
      .catch((err) => {
        console.log('Error in App.js, calling /v1/report');
        console.log(err);
      });
        // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, orgId, locationId]);

  const sortData = async (data) => {
    let fullData = [];
    let stop = '';
    let startTimes = [];
    let i = 0;
    let total = '';

    data.forEach((row) => {
      // Save start time
      if (
        row.type === 'start' &&
        row.eb_organization_id === orgId &&
        row.eb_location_id === locationId
      ) {
        startTimes.push({ time: row.ts, id: row.session_id });
      }
      // Save data when stop timestamp is found
      if (
        row.type === 'stop' &&
        row.eb_organization_id === orgId &&
        row.eb_location_id === locationId
      ) {
        // Find the start time that matches stop time
        let start = startTimes.find((item) => item.id === row.session_id);
        // Save stop time
        stop = row.ts;
        const stopDate = new Date(stop);
        const stopDateWithLocalOffset = new Date(
          stopDate.setMinutes(
            stopDate.getMinutes() - stopDate.getTimezoneOffset()
          )
        );

        // Duplicate stop times or only stop time saved --> Do nothing
        if (!start) return;

        const startDate = new Date(start.time);
        const startDateWithLocalOffset = new Date(
          startDate.setMinutes(
            startDate.getMinutes() - startDate.getTimezoneOffset()
          )
        );
        // Catch error if there are duplicate start/stop times in DB
        try {
          total = (new Date(stop) - new Date(start.time)) / 1000;

          // Generate "correct" sessionId for each session
          i += 1;

          fullData.push({
            id: i,
            area: row.area,
            date: new Date(stop).toLocaleDateString(),
            start: startDateWithLocalOffset.toLocaleTimeString(),
            stop: stopDateWithLocalOffset.toLocaleTimeString(),
            total: formatTime(total),
            asset_ids: row.eb_asset_ids,
          });
        } catch (error) {
          console.log(error);
          console.log('Problematic timestamp: ');
          console.log(start);
          console.log(stop);
          console.log('id: ' + i);
          return setError(true);
        }

        startTimes = [];
        stop = '';
      }
    });
    // Reverse array again to display data starting from most recent value
    fullData.reverse();
    setReportData(fullData);
  };

  // Store data for the Table
  const data = React.useMemo(() => reportData, [reportData]);

  // Create columns for the Table

  const columns = React.useMemo(
    () => [
      {
        title: 'Session ID',
        field: 'id', // accessor is the "key" in the data
      },
      {
        title: 'Area',
        field: 'area',
      },
      {
        title: 'Date',
        field: 'date',
      },
    ],
    []
  );

  if (hasError) {
    return (
      <div>
        <h3>There is a problem with the report view.</h3>
        <p>
          Please contact <b>eb.support@haltian.com</b>
        </p>
      </div>
    );
  }

  return (
    <div style={{ marginBottom: '2rem' }}>
      <MaterialTable
        columns={columns}
        data={data}
        title="Cleaning report"
        options={
          isUserRoleAtleastService && {
            exportMenu: [
              {
                label: 'Export CSV',
                exportFunc: (cols, datas) => {
                  const columns = Object.keys(data[0]);
                  const reportColumns = columns.map((column) => {
                    return {
                      field: column,
                      tableData: {},
                      title: column,
                    };
                  });
                  return ExportCsv(reportColumns, data, 'Reservations_report');
                },
              },
              {
                label: 'Export Excel',
                exportFunc: (cols, datas) => {
                  const dataArray = data.map((object) => Object.values(object));
                  dataArray.unshift(Object.keys(data[0]));
                  exportExcel(dataArray, pathIds);
                },
              },
            ],
          }
        }
      />
    </div>
  );
};

export default CleaningReport;
